import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search-nav"
export default class extends Controller {
  static targets = ["searchIcon", "searchInput"]

  connect() {
  }

  toggleSearch() {
    this.searchIconTarget.classList.toggle("hidden")
    this.searchInputTarget.classList.toggle("hidden")

    this.searchInputTarget.querySelector("input").focus();
  }
}
